import {
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  IconButton,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { adminService } from '../../services/adminService';

const RoleForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditando = !!id;

  const [formData, setFormData] = useState({
    nome: '',
    descricao: ''
  });
  const [loading, setLoading] = useState(false);
  const [carregando, setCarregando] = useState(isEditando);
  const [error, setError] = useState('');
  const [erros, setErros] = useState({});

  useEffect(() => {
    if (isEditando) {
      carregarRole();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const carregarRole = async () => {
    setCarregando(true);
    try {
      const role = await adminService.buscarRole(id);
      setFormData({
        nome: role.nome || '',
        descricao: role.descricao || ''
      });
    } catch (err) {
      setError(err.message || 'Erro ao carregar role');
    } finally {
      setCarregando(false);
    }
  };

  const validarFormulario = () => {
    const novosErros = {};

    if (!formData.nome || formData.nome.length < 2) {
      novosErros.nome = 'Nome deve ter no mínimo 2 caracteres';
    }

    if (formData.nome.length > 100) {
      novosErros.nome = 'Nome deve ter no máximo 100 caracteres';
    }

    if (!formData.descricao || formData.descricao.length < 3) {
      novosErros.descricao = 'Descrição deve ter no mínimo 3 caracteres';
    }

    if (formData.descricao.length > 255) {
      novosErros.descricao = 'Descrição deve ter no máximo 255 caracteres';
    }

    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!validarFormulario()) {
      return;
    }

    setLoading(true);
    try {
      if (isEditando) {
        await adminService.editarRole(id, formData);
      } else {
        await adminService.criarRole(formData);
      }

      navigate('/admin/roles');
    } catch (err) {
      setError(err.message || 'Erro ao salvar role');
    } finally {
      setLoading(false);
    }
  };

  if (carregando) {
    return (
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <IconButton onClick={() => navigate('/admin/roles')} sx={{ mr: 2 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
          {isEditando ? 'Editar Role' : 'Criar Role'}
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      <Paper sx={{ p: 4 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Nome"
            value={formData.nome}
            onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
            margin="normal"
            required
            error={!!erros.nome}
            helperText={erros.nome}
            disabled={loading}
            inputProps={{ maxLength: 100 }}
          />

          <TextField
            fullWidth
            label="Descrição"
            value={formData.descricao}
            onChange={(e) => setFormData({ ...formData, descricao: e.target.value })}
            margin="normal"
            required
            multiline
            rows={3}
            error={!!erros.descricao}
            helperText={erros.descricao}
            disabled={loading}
            inputProps={{ maxLength: 255 }}
          />

          <Box sx={{ display: 'flex', gap: 2, mt: 4 }}>
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{ flex: 1 }}
            >
              {loading ? <CircularProgress size={24} /> : 'Salvar'}
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate('/admin/roles')}
              disabled={loading}
            >
              Cancelar
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default RoleForm;




